import { useLoaderData } from "react-router-dom";
import { Content } from "antd/es/layout/layout";
import { Typography } from "antd";
import { ReviewStatusTag } from "./components";
import { ServiceRequestDetailsPageLoaderType } from "./loaders";
import { useAppTranslation } from "~/hooks/useAppTranslation";
const { Title, Text, Paragraph } = Typography;

export const ServiceRequestDetailsPage = () => {
  const loaderData =
    useLoaderData() as unknown as ServiceRequestDetailsPageLoaderType;
  const { t } = useAppTranslation();

  return (
    <Content className="service-request-detail">
      <Title className="service-request-detail-title" level={1}>
        {t("Service_Request_Details")}
      </Title>
      <Paragraph className="service-request-detail-item">
        <Text strong>{t("Title")}: </Text> {loaderData.serviceRequest.title}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>{t("Status")}: </Text>
        <ReviewStatusTag status={loaderData.serviceRequest.status} />
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>{t("Created_At")}: </Text>{" "}
        {loaderData.serviceRequest.createdAt}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>{t("Updated_At")}: </Text>{" "}
        {loaderData.serviceRequest.updatedAt}
      </Paragraph>
      <Paragraph className="service-request-detail-item">
        <Text strong>{t("Type")}: </Text> {loaderData.serviceRequest.type}
      </Paragraph>
    </Content>
  );
};
